(function () {
    var DEFAULT_MIN_QTY_PER_VARIANT = 1;
    var DEFAULT_MAX_QTY_PER_VARIANT = 9999;

  var ADDED_TEXT = 'Added to cart';

  var PRODUCT_ERROR_CLASS = 'custom-cart-limit-message';
  var CART_ERROR_CLASS = 'custom-cart-item-limit-message';

  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      cache: 'no-store',
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to fetch cart');
      return response.json();
    });
  }

  function getMinQtyFromElement(element) {
    if (!element) return DEFAULT_MIN_QTY_PER_VARIANT;

    var directMinQty = element.getAttribute('data-min-qty');
    var parentWithMinQty = element.closest('[data-min-qty]');
    var parentMinQty = parentWithMinQty ? parentWithMinQty.getAttribute('data-min-qty') : null;

    var minQty = directMinQty || parentMinQty;

    minQty = parseInt(minQty, 10);

    if (isNaN(minQty) || minQty < 1) {
        return DEFAULT_MIN_QTY_PER_VARIANT;
    }

    return minQty;
    }

  function getMaxQtyFromElement(element) {
    if (!element) return DEFAULT_MAX_QTY_PER_VARIANT;

    var directMaxQty = element.getAttribute('data-max-qty');
    var parentWithMaxQty = element.closest('[data-max-qty]');
    var parentMaxQty = parentWithMaxQty ? parentWithMaxQty.getAttribute('data-max-qty') : null;

    var maxQty = directMaxQty || parentMaxQty;

    maxQty = parseInt(maxQty, 10);

    if (isNaN(maxQty) || maxQty < 1) {
      return DEFAULT_MAX_QTY_PER_VARIANT;
    }

    return maxQty;
  }

    function getCartMinLimitMessage(minQty) {
        return 'Minimum ' + minQty + ' units required for this product.';
    }

    function getCartMaxLimitMessage(maxQty) {
        return 'Maximum ' + maxQty + ' units allowed for this product.';
    }

  function getProductForms() {
    return document.querySelectorAll('form[action*="/cart/add"]');
  }

  function getCurrentVariantId(form) {
    if (!form) return null;

    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) return null;

    return String(variantInput.value);
  }

  function getQuantityToAdd(form) {
    if (!form) return 1;

    var quantityInput = form.querySelector('[name="quantity"]');

    if (!quantityInput || !quantityInput.value) return 1;

    var qty = parseInt(quantityInput.value, 10);

    if (isNaN(qty) || qty < 1) return 1;

    return qty;
  }

  function getVariantQtyInCart(cart, variantId) {
    if (!cart || !cart.items || !variantId) return 0;

    var matchedItem = cart.items.find(function (item) {
      return String(item.variant_id) === String(variantId);
    });

    return matchedItem ? Number(matchedItem.quantity || 0) : 0;
  }

  function getAddButton(form) {
    return form.querySelector('[data-js-product-add-to-cart]');
  }

  function getButtonTextElement(form) {
    return form.querySelector('[data-js-product-add-to-cart-text]');
  }

  function storeDefaultButtonText(buttonText) {
    if (!buttonText) return;

    if (!buttonText.dataset.defaultText) {
      buttonText.dataset.defaultText = buttonText.textContent.trim() || 'Add to cart';
    }
  }

  function getDefaultButtonText(buttonText) {
    if (!buttonText) return 'Add to cart';

    storeDefaultButtonText(buttonText);

    return buttonText.dataset.defaultText || 'Add to cart';
  }

  function getLimitMessage(maxQty) {
    return 'You can add a maximum of ' + maxQty + ' units of this product to the cart.';
  }

  function getCartLimitMessage(maxQty) {
    return 'Maximum ' + maxQty + ' units allowed for this product.';
  }

  function removeProductLimitMessage(form) {
    if (!form) return;

    var oldMessage = form.querySelector('.' + PRODUCT_ERROR_CLASS);

    if (oldMessage) {
      oldMessage.remove();
    }
  }

  function showProductLimitMessage(form, message) {
    if (!form) return;

    removeProductLimitMessage(form);

    var button = getAddButton(form);
    var msg = document.createElement('div');

    msg.className = PRODUCT_ERROR_CLASS;
    msg.textContent = message;
    msg.setAttribute('role', 'alert');

    if (button && button.parentNode) {
      button.parentNode.insertBefore(msg, button.nextSibling);
    } else {
      form.appendChild(msg);
    }
  }

  function updateSingleFormButton(form, cart) {
    if (!form || !cart) return;

    var button = getAddButton(form);
    var buttonText = getButtonTextElement(form);
    var variantId = getCurrentVariantId(form);

    if (!button || !buttonText || !variantId) return;

    storeDefaultButtonText(buttonText);

    var maxQty = getMaxQtyFromElement(button);
    var qtyInCart = getVariantQtyInCart(cart, variantId);

    // if (qtyInCart > 0) {
    //   button.classList.add('is-added-to-cart');
    //   buttonText.textContent = ADDED_TEXT;
    // } else {
    //   button.classList.remove('is-added-to-cart');
    //   buttonText.textContent = getDefaultButtonText(buttonText);
    //   removeProductLimitMessage(form);
    // }

    var shouldDisableIfInCart = button.getAttribute('data-disable-if-in-cart') === 'true';

    if (qtyInCart > 0) {
    button.classList.add('is-added-to-cart');
    buttonText.textContent = ADDED_TEXT;

    if (shouldDisableIfInCart) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('data-already-in-cart', 'true');
        button.classList.add('disabled', 'is-already-in-cart-disabled');
    }
    } else {
    button.classList.remove('is-added-to-cart', 'is-already-in-cart-disabled');
    buttonText.textContent = getDefaultButtonText(buttonText);
    removeProductLimitMessage(form);

    if (shouldDisableIfInCart) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.removeAttribute('data-already-in-cart');
        button.classList.remove('disabled');
    }
    }

    if (qtyInCart >= maxQty) {
      button.classList.add('is-cart-limit-reached');
      button.setAttribute('data-cart-limit-reached', 'true');
    } else {
      button.classList.remove('is-cart-limit-reached');
      button.removeAttribute('data-cart-limit-reached');
    }
  }

  function updateAllProductButtons() {
    fetchCart()
      .then(function (cart) {
        getProductForms().forEach(function (form) {
          updateSingleFormButton(form, cart);
        });
      })
      .catch(function (error) {
        console.warn('Cart button refresh failed:', error);
      });
  }

  function validateBeforeSubmit(form) {
    return fetchCart().then(function (cart) {
      var button = getAddButton(form);
      var maxQty = getMaxQtyFromElement(button);

      var variantId = getCurrentVariantId(form);
      var qtyToAdd = getQuantityToAdd(form);
      var existingQty = getVariantQtyInCart(cart, variantId);
      var finalQty = existingQty + qtyToAdd;

      if (finalQty > maxQty) {
        showProductLimitMessage(form, getLimitMessage(maxQty));
        updateSingleFormButton(form, cart);
        return false;
      }

      removeProductLimitMessage(form);

      return true;
    });
  }

  function bindSubmitValidation() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target.closest('form[action*="/cart/add"]');

        if (!form) return;

        if (form.dataset.customCartValidationRunning === 'true') {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        validateBeforeSubmit(form)
          .then(function (canSubmit) {
            if (!canSubmit) return;

            form.dataset.customCartValidationRunning = 'true';

            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              form.submit();
            }

            setTimeout(function () {
              delete form.dataset.customCartValidationRunning;
              updateAllProductButtons();
              validateCartQuantitiesState();
            }, 1200);

            setTimeout(function () {
              updateAllProductButtons();
              validateCartQuantitiesState();
            }, 2200);
          })
          .catch(function (error) {
            console.warn('Cart validation failed:', error);

            delete form.dataset.customCartValidationRunning;
            form.dataset.customCartValidationRunning = 'true';

            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              form.submit();
            }

            setTimeout(function () {
              delete form.dataset.customCartValidationRunning;
              updateAllProductButtons();
              validateCartQuantitiesState();
            }, 1200);
          });
      },
      true
    );
  }

  function getCartItemContainer(element) {
    if (!element) return null;

    return element.closest('[data-js-cart-item], .cart-item, .cart__item, .cart-form__item, tr, li');
  }

  function getCartQuantityInputFromContainer(container) {
    if (!container) return null;

    return container.querySelector(
      'input[name="updates[]"], input[name^="updates"], input[type="number"], .quantity-selector input'
    );
  }

  function removeCartLimitMessage(container) {
    if (!container) return;

    var wrapper = container.closest('[data-cart-item-limit-wrapper]');
    var scope = wrapper || container;

    scope.querySelectorAll('.' + CART_ERROR_CLASS).forEach(function (oldMessage) {
        oldMessage.remove();
    });
    }

    function getCartItemWrapper(container) {
        if (!container) return null;

        /*
            Supports both structures:

            1. Sidebar:
            <div class="cart-item-limit-wrapper">
            <div class="cart-item">...</div>
            </div>

            2. Cart page:
            <div class="cart-form-item">
            <div class="cart-item__product-info">...</div>
            <div class="cart-item-limit-wrapper"></div>
            </div>
        */

        var parentWrapper = container.closest('[data-cart-item-limit-wrapper], .cart-item-limit-wrapper');

        if (parentWrapper) {
            return parentWrapper;
        }

        var childWrapper = container.querySelector('[data-cart-item-limit-wrapper], .cart-item-limit-wrapper');

        if (childWrapper) {
            return childWrapper;
        }

        return null;
        }

        function removeCartLimitMessage(container) {
        if (!container) return;

        var wrapper = getCartItemWrapper(container);

        /*
            Remove messages from both:
            1. wrapper
            2. cart item container

            This cleans old wrongly placed messages like:
            <div class="cart-form-item">
            ...
            <div class="cart-item-limit-wrapper"></div>
            <div class="custom-cart-item-limit-message">...</div>
            </div>
        */

        if (wrapper) {
            wrapper.querySelectorAll('.' + CART_ERROR_CLASS).forEach(function (oldMessage) {
            oldMessage.remove();
            });
        }

        container.querySelectorAll('.' + CART_ERROR_CLASS).forEach(function (oldMessage) {
            oldMessage.remove();
        });
        }

        function showCartLimitMessage(container, message) {
        if (!container) return;

        removeCartLimitMessage(container);

        var wrapper = getCartItemWrapper(container);

        /*
            Do not create wrapper from JS.
            Use only existing Liquid wrapper.
        */

        if (!wrapper) {
            console.warn('Cart limit wrapper not found for item:', container);
            return;
        }

        var msg = document.createElement('div');
        msg.className = CART_ERROR_CLASS;
        msg.textContent = message;
        msg.setAttribute('role', 'alert');

        wrapper.appendChild(msg);

        setTimeout(function () {
            if (msg && msg.parentNode) {
            msg.remove();
            }
        }, 10000);
        }

  function isPlusButton(element) {
    if (!element) return false;

    var button = element.closest('button, a, [role="button"], .quantity__button, .quantity-selector__button');

    if (!button) return false;

    var text = (button.textContent || '').trim().toLowerCase();
    var aria = (button.getAttribute('aria-label') || '').toLowerCase();
    var name = (button.getAttribute('name') || '').toLowerCase();
    var dataAction = (button.getAttribute('data-action') || '').toLowerCase();
    var className = (button.className || '').toString().toLowerCase();

    return (
      text === '+' ||
      aria.includes('increase') ||
      aria.includes('plus') ||
      name === 'plus' ||
      dataAction.includes('plus') ||
      dataAction.includes('increase') ||
      className.includes('plus') ||
      className.includes('increase')
    );
  }

  function isMinusButton(element) {
    if (!element) return false;

    var button = element.closest('button, a, [role="button"], .quantity__button, .quantity-selector__button');

    if (!button) return false;

    var text = (button.textContent || '').trim().toLowerCase();
    var aria = (button.getAttribute('aria-label') || '').toLowerCase();
    var name = (button.getAttribute('name') || '').toLowerCase();
    var dataAction = (button.getAttribute('data-action') || '').toLowerCase();
    var className = (button.className || '').toString().toLowerCase();

    return (
      text === '-' ||
      text === '−' ||
      aria.includes('decrease') ||
      aria.includes('minus') ||
      name === 'minus' ||
      dataAction.includes('minus') ||
      dataAction.includes('decrease') ||
      className.includes('minus') ||
      className.includes('decrease')
    );
  }

  function bindCartQuantityLimitMessage() {
    document.addEventListener(
      'click',
      function (event) {
        if (!isPlusButton(event.target)) return;

        var container = getCartItemContainer(event.target);
        var input = getCartQuantityInputFromContainer(container);

        if (!container || !input) return;

        var currentQty = parseInt(input.value, 10);

        if (isNaN(currentQty)) currentQty = 1;

        var maxQty = getMaxQtyFromElement(input);

        if (currentQty >= maxQty) {
          event.preventDefault();
          event.stopImmediatePropagation();

          input.value = maxQty;

          showCartLimitMessage(container, getCartLimitMessage(maxQty));

          setTimeout(function () {
            validateCartQuantitiesState();
            updateAllProductButtons();
          }, 400);

          return false;
        }

        setTimeout(function () {
          validateCartQuantitiesState();
          updateAllProductButtons();
        }, 800);
      },
      true
    );

    document.addEventListener(
    'click',
    function (event) {
        if (!isMinusButton(event.target)) return;

        var container = getCartItemContainer(event.target);
        var input = getCartQuantityInputFromContainer(container);

        if (!container || !input) return;

        var currentQty = parseInt(input.value, 10);
        if (isNaN(currentQty)) currentQty = 1;

        var minQty = getMinQtyFromElement(input);

        if (currentQty <= minQty) {
        event.preventDefault();
        event.stopImmediatePropagation();

        input.value = minQty;

        showCartLimitMessage(container, getCartMinLimitMessage(minQty));

        setTimeout(function () {
            validateCartQuantitiesState();
            updateAllProductButtons();
        }, 400);

        return false;
        }

        setTimeout(function () {
        validateCartQuantitiesState();
        updateAllProductButtons();
        }, 800);

        setTimeout(function () {
        validateCartQuantitiesState();
        updateAllProductButtons();
        }, 1600);
    },
    true
    );
  }

  function bindManualCartQuantityValidation() {
    document.addEventListener(
      'change',
      function (event) {
        var input = event.target.closest(
          '#cart input[name="updates[]"], #site-cart-sidebar input[name="updates[]"], .cart-form input[name="updates[]"], input[name="updates[]"]'
        );

        if (!input) return;

        var container = getCartItemContainer(input);
        var qty = parseInt(input.value, 10);
        var minQty = getMinQtyFromElement(input);
        var maxQty = getMaxQtyFromElement(input);

        if (isNaN(qty) || qty < 1) return;

        if (qty < minQty) {
            event.preventDefault();
            event.stopImmediatePropagation();

            input.value = minQty;
            showCartLimitMessage(container, getCartMinLimitMessage(minQty));

            input.dispatchEvent(new Event('input', { bubbles: true }));

            setTimeout(function () {
                validateCartQuantitiesState();
                updateAllProductButtons();
            }, 800);

            return false;
        }

        if (qty > maxQty) {
          event.preventDefault();
          event.stopImmediatePropagation();

          input.value = maxQty;
          showCartLimitMessage(container, getCartLimitMessage(maxQty));

          input.dispatchEvent(new Event('input', { bubbles: true }));

          setTimeout(function () {
            validateCartQuantitiesState();
            updateAllProductButtons();
          }, 800);

          return false;
        }

        removeCartLimitMessage(container);

        setTimeout(function () {
          validateCartQuantitiesState();
          updateAllProductButtons();
        }, 800);
      },
      true
    );
  }

  function validateCartQuantitiesState() {
    var cartQtyInputs = document.querySelectorAll(
      '#cart input[name="updates[]"], #site-cart-sidebar input[name="updates[]"], .cart-form input[name="updates[]"], input[name="updates[]"]'
    );

    cartQtyInputs.forEach(function (input) {
      var container = getCartItemContainer(input);
      var qty = parseInt(input.value, 10);
      var minQty = getMinQtyFromElement(input);
        var maxQty = getMaxQtyFromElement(input);

      if (isNaN(qty) || !container) return;


      if (qty >= maxQty || qty <= minQty) {
        container.classList.add('is-cart-item-limit-reached');
        } else {
        container.classList.remove('is-cart-item-limit-reached');
        removeCartLimitMessage(container);
        }
    });
  }

  function bindVariantChangeRefresh() {
    document.addEventListener('change', function (event) {
      var form = event.target.closest('form[action*="/cart/add"]');

      if (!form) return;

      setTimeout(updateAllProductButtons, 250);
    });
  }

  function bindCartRefreshEvents() {
    document.addEventListener('click', function (event) {
      var removeTrigger = event.target.closest(
        '[data-js-cart-item-remove], [data-js-cart-remove], .cart-item__remove, .cart__remove, a[href*="/cart/change"]'
      );

      var quantityTrigger = event.target.closest(
        '[data-js-quantity-selector], quantity-selector, .quantity-selector, .quantity__button, button[name="minus"], button[name="plus"]'
      );

      if (removeTrigger || quantityTrigger) {
        setTimeout(updateAllProductButtons, 500);
        setTimeout(validateCartQuantitiesState, 500);

        setTimeout(updateAllProductButtons, 1200);
        setTimeout(validateCartQuantitiesState, 1200);

        setTimeout(updateAllProductButtons, 2200);
        setTimeout(validateCartQuantitiesState, 2200);
      }
    });

    document.addEventListener('change', function (event) {
      var cartQtyInput = event.target.closest(
        '#cart [name="updates[]"], #site-cart-sidebar [name="updates[]"], .cart-form [name="updates[]"], input[name="updates[]"]'
      );

      if (cartQtyInput) {
        setTimeout(updateAllProductButtons, 500);
        setTimeout(validateCartQuantitiesState, 500);

        setTimeout(updateAllProductButtons, 1200);
        setTimeout(validateCartQuantitiesState, 1200);

        setTimeout(updateAllProductButtons, 2200);
        setTimeout(validateCartQuantitiesState, 2200);
      }
    });

    document.addEventListener('cart:updated', function () {
      updateAllProductButtons();
      validateCartQuantitiesState();
    });

    document.addEventListener('cart:refresh', function () {
      updateAllProductButtons();
      validateCartQuantitiesState();
    });

    document.addEventListener('cart:change', function () {
      updateAllProductButtons();
      validateCartQuantitiesState();
    });

    document.addEventListener('cart:build', function () {
      updateAllProductButtons();
      validateCartQuantitiesState();
    });

    document.addEventListener('product:added', function () {
      updateAllProductButtons();
      validateCartQuantitiesState();
    });
  }

  function observeCartDrawerChanges() {
    var targets = [];

    var cartDrawer = document.querySelector('#site-cart-sidebar');
    var cartForm = document.querySelector('.cart-form');
    var cartPage = document.querySelector('#cart');

    if (cartDrawer) targets.push(cartDrawer);
    if (cartForm) targets.push(cartForm);
    if (cartPage) targets.push(cartPage);

    if (!targets.length || !window.MutationObserver) return;

    var observerTimer = null;

    var observer = new MutationObserver(function () {
      clearTimeout(observerTimer);

      observerTimer = setTimeout(function () {
        updateAllProductButtons();
        validateCartQuantitiesState();
      }, 400);
    });

    targets.forEach(function (target) {
      observer.observe(target, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    });
  }

  function observeQuickViewChanges() {
    var quickView = document.querySelector('#product-quick-view, #modal-common, .product-quick-view');

    if (!quickView || !window.MutationObserver) return;

    var observerTimer = null;

    var observer = new MutationObserver(function () {
        clearTimeout(observerTimer);

        observerTimer = setTimeout(function () {
        updateAllProductButtons();
        }, 400);
    });

    observer.observe(quickView, {
        childList: true,
        subtree: true,
        attributes: true,
    });
   }

 
    function init() {
    updateAllProductButtons();
    validateCartQuantitiesState();

    bindSubmitValidation();
    bindCartQuantityLimitMessage();
    bindManualCartQuantityValidation();
    bindVariantChangeRefresh();
    bindCartRefreshEvents();
    observeCartDrawerChanges();

    setTimeout(updateAllProductButtons, 1000);
    setTimeout(validateCartQuantitiesState, 1000);

    document.addEventListener('click', function (event) {
        var quickViewTrigger = event.target.closest(
            '[data-js-product-quick-view], [data-js-quick-view], .product-item__quick-view, .quick-view'
        );

        if (!quickViewTrigger) return;

        setTimeout(updateAllProductButtons, 600);
        setTimeout(updateAllProductButtons, 1200);
        setTimeout(updateAllProductButtons, 2000);
    });

    observeQuickViewChanges();

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();